import request from '@/request/request'

/**
 * // 阿里云图形验证登录业务
 * @param {} parameter 
 * @returns 
 */
export function aliyunPhotoCaptchaLogin (parameter) {
  return request({
    url: '/external-service-center/aliyunPhotoCaptcha/login',
    method: 'post',
    data: parameter
  })
}

/**
 * 获取切换企业列表
 * @param {} parameter 
 * @returns 
 */
export function listSwitchAccount (parameter) {
  return request({
    url: '/e-find-user/testLogin/listSwitchAccount',
    method: 'get',
    data: parameter
  })
}

/**
 * 切换企业
 * @param {} parameter 
 * @returns 
 */
export function switchAccount (parameter) {
  return request({
    url: '/e-find-user/testLogin/switchAccount',
    method: 'post',
    data: parameter
  })
}

export function enterprisePasswordResetContext (parameter) {
  return request({
    url: '/e-find-user/testLogin/enterprisePasswordReset/context',
    method: 'post',
    data: parameter
  })
}

export function sendEnterprisePasswordResetCode (parameter) {
  return request({
    url: '/e-find-user/testLogin/enterprisePasswordReset/sendCode',
    method: 'post',
    data: parameter
  })
}

export function verifyEnterprisePasswordResetCode (parameter) {
  return request({
    url: '/e-find-user/testLogin/enterprisePasswordReset/verifyCode',
    method: 'post',
    data: parameter
  })
}

export function resetEnterprisePassword (parameter) {
  return request({
    url: '/e-find-user/testLogin/enterprisePasswordReset/resetPassword',
    method: 'post',
    data: parameter
  })
}

export function logout () {
  return request({
    url: '/e-find-user/testLogin/logout',
    method: 'post'
  })
}
